import { TFunction } from 'i18next';

import { NOPStrategyItems } from '../../../shared/types';
import { getActiveStrategyByName } from '../PriceViewer';
import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';
class NOPStrategy extends DataSetSeriesGenerator {
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = true;
  activeStrategy: string;
  strategyMode: string;

  nopStrategy: readonly NOPStrategyItems[];

  constructor(
    nopStrategy: readonly NOPStrategyItems[],
    activeStrategy: string,
    t: TFunction,
    strategyMode: string
  ) {
    super(t);
    this.nopStrategy = nopStrategy;
    this.activeStrategy = activeStrategy;
    this.strategyMode = strategyMode;
  }

  getChartName(): string {
    return this.activeStrategy + ' ' + this.t('strategy-return');
  }

  getSeries(): PriceViewerSeries {
    const strategy = getActiveStrategyByName(this.activeStrategy);
    const isSimpleMode = this.strategyMode === 'simple-mode';
    const strategyCapitalData = this.nopStrategy.map(item => [
      item['date'],
      isSimpleMode
        ? item['open']
        : (item['open'] / item['capital_sh']) * item[strategy + '_capital'] ===
              Number.POSITIVE_INFINITY ||
            (item['open'] / item['capital_sh']) *
              item[strategy + '_capital'] ===
              undefined
          ? null
          : (item['open'] / item['capital_sh']) * item[strategy + '_capital'],
      item[strategy + '_capital'],
    ]);
    return {
      name: this.getChartName(),
      echartSeries: {
        type: 'line',
        data: strategyCapitalData,
        connectNulls: true,
        symbol: 'none',
        lineStyle: {
          color: isSimpleMode ? 'rgba(255,255,255,0)' : '#003366',
        },
        markLine: {
          symbol: ['none', 'none'],
          animation: false,
          lineStyle: {
            width: isSimpleMode ? 0 : 1,
            color: 'black',
          },
          data: [
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            { name: 'Forward Test', xAxis: '2022-01-03' },
          ],
        },
      },
      tooltipFormatter: isSimpleMode
        ? null
        : getDefaultToolptipFormatter('3x2d', 'percentage', {
            keyColor: '#003366',
          }),
    };
  }
}

export default NOPStrategy;
